<template>
  <div>
    <CommonModal
      class="confirm-modal"
      :title="dataSource.afficheTitle"
      :footer="null"
      :width="684"
      :maskClosable="false"
      :closable="dataSource.forceReadFlag !== 1"
      v-bind="$attrs"
      v-on="$listeners"
      v-if="dataSource.alterShowType === 1"
    >
      <div class="confirm-modal-inner">
        <div class='modal-content' v-html="dataSource.alterContent"></div>
        <p class='confirm-modal-button-warp'>
          <a-button class="confirm-modal-button" target='_blank' type="primary" @click="onStart">查看详情</a-button>
          <a-button class="confirm-modal-button" target='_blank' @click="onCancel" :disabled="isDisable">关闭{{isDisable ?`(${reminSeconds}s)`: ''}}</a-button>
        </p>
      </div>
    </CommonModal>
    <CommonModal
      wrapClassName='announcement-modal-img'
      :footer="null"
      :closable="false"
      :width="648"
      :maskClosable="false"
      v-bind="$attrs"
      v-on="$listeners"
      v-if="dataSource.alterShowType === 2"
    >
      <div class='modal-img-inner'>
        <div class='inner-box'>
          <a-icon type="close-circle" class='inner-icon' @click="onCancel"/>
          <img class='inner-img' :src="dataSource.alterPcImageUrl" alt="" @click="onStart">
        </div>
      </div>
    </CommonModal>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { Button, Icon } from 'ant-design-vue'
  import CommonModal from '@/components/common-modal'

  export default {
    name: "announcement-modal",
    components: {
      CommonModal,
      [Button.name]: Button,
      [Icon.name]: Icon,
    },
    props: {
      dataSource: Object
    },
    data() {
      return {
        reminSeconds: 5,
      }
    },
    computed: {
      isDisable() {
        const { alterShowType, forceReadFlag } = this.dataSource || {}
        if (alterShowType === 1 && forceReadFlag === 1 && this.reminSeconds > 0) {
          return true
        }
        return false
      }
    },
    async created() {
      // console.log(this.$attrs, this.$listeners)
    },
    beforeDestroy() {
      clearTimeout(this.timer)
    },
    methods: {
      ...mapActions('popHome',[
        'setAnnouncementFlag'
      ]),
      handleForceRead() {
        if (this.isDisable) {
          this.timer = setTimeout(() => {
            this.reminSeconds -= 1
            this.handleForceRead()
          }, 1000)
        }
      },
      onCancel () {
        this.$emit('cancel')
      },

      onStart() {
        const { afficheId } = this.dataSource || {}
        this.setAnnouncementFlag({afficheId, operationType: 2})
        // 跳转新公告详情
        window.open(`${process.env.VUE_APP_SEVERENV === 'BETA' ? 'http' : 'https'}://open.haiziwang.com/platform?afficheId=${afficheId}`)
      },
    },
    watch: {
      '$attrs.visible': function (val) {
        if (val) {
          this.handleForceRead()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.confirm-modal-inner{
  // padding: 25px 40px;
  // height: 290px;
  // overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .modal-content{
    max-height: 400px;
    overflow-y: auto;
    padding-left: 10px;
    font-size: 16px;
    // text-indent: 36px;
    line-height: 32px;
    .content{
      margin-top: 10px;
    }
  }
}
.confirm-modal-button-warp{
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.confirm-modal-button{
  // height: 32px;
  line-height: 32px;
  // background: $primary-main;
  // color: #fff;
  // display: block;
  // border-radius: 4px;
  &:nth-child(n+1){
    margin-left: 20px;
  }
}
.announcement-modal-img{
  .modal-img-inner{
    position: relative;
    .inner-box{
      .inner-icon{
        position: absolute;
        color: white;
        font-size: 30px;
        right: -30px;
        top: -30px;
        cursor: pointer;
      }
      .inner-img{
        cursor: pointer;
        width: 600px;
        border-radius: 5px;
      }
    }
  }
}

</style>
<style lang="scss">
.announcement-modal-img{
  .ant-modal-content{
    background: rgba(0, 0, 0, 0);
    box-shadow: 0 0;
  }
}
</style>
